import React from 'react';
import styled from '@emotion/styled';
import { softBlack50 } from '../consts/variables';

const Wrapper = styled.div`
    text-align: center;
    color: ${softBlack50};
    font-size: 12px;
    line-height: 19px;
    margin-top: 16px;
`;

export const CalamityFundChargeText = () => {
    return (
        <Wrapper>
            Exclusief Calamiteitenfonds à € 2.50 per reservering en SGR bijdrage à € 5,- per persoon
        </Wrapper>
    );
};
